import IconClose from '@apollo/icons/small/IconClose.svg';
import { IconButton, Spinner } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { useExplorerState } from 'src/app/graph/explorerPage/hooks/useExplorerState/useExplorerState';
import { Tooltip } from 'src/components/common/tooltip/Tooltip';

export const SubscriptionsStatus = ({
  socketStatus,
  isListening,
  stopListening,
  subscriptionUrl,
}: Pick<
  ReturnType<typeof useExplorerState>['subscription'],
  'socketStatus' | 'isListening' | 'stopListening'
> & {
  subscriptionUrl: string | null;
}) => {
  return (
    <div className="flex flex-none items-center text-xs tracking-wider text-primary">
      {socketStatus === 'connecting' ? (
        <Spinner variant="neutral" size="tiny" className="-mr-1 ml-1" />
      ) : (
        <Tooltip
          label={`${
            socketStatus === 'connected' ? 'Connected' : 'Unable to connect'
          } to ${subscriptionUrl}`}
        >
          <div
            className={classnames(
              'mr-2 inline-block size-2 rounded-full',
              socketStatus === 'connected' ? 'bg-green' : 'bg-red',
            )}
          />
        </Tooltip>
      )}
      <span className="uppercase">Status</span>

      {isListening && socketStatus === 'connected' && (
        <div className="ml-2 flex items-center border-l border-l-primary pl-2">
          <Tooltip label="Stop listening for subscription">
            <IconButton
              aria-label="Stop listening for subscription"
              size="sm"
              variant="hidden"
              onClick={stopListening}
              icon={<IconClose />}
            />
          </Tooltip>
          Listening
          <Spinner variant="neutral" size="tiny" className="ml-1" />
        </div>
      )}
    </div>
  );
};
